import { deriveInboundStatus } from '../../utils/inboundShipment';
import { initialState } from '../reducers/inbound';
import { peek, selector } from '../selectorHelpers';

export const inboundSelect = (state) => state.get('inbound', initialState);

export const inboundSelectItems = selector(inboundSelect, peek('items'));
export const inboundSelectLoading = selector(inboundSelect, peek('isLoading'));
export const inboundSelectTotal = selector(inboundSelect, peek('total'));
export const inboundSelectParams = selector(inboundSelect, peek('params'));

export const inboundSelectDetails = selector(inboundSelect, peek('details'));
export const inboundSelectDetailLoadingId = selector(
  inboundSelect,
  peek('detailLoadingId'),
);

export const inboundSelectAddresses = selector(
  inboundSelect,
  peek('addresses'),
);
export const inboundSelectAddressesLoading = selector(
  inboundSelect,
  peek('isAddressesLoading'),
);
export const inboundSelectAddressesLoaded = selector(
  inboundSelect,
  peek('addressesLoaded'),
);

export const inboundSelectEstimating = selector(
  inboundSelect,
  peek('isEstimating'),
);
export const inboundSelectShipping = selector(
  inboundSelect,
  peek('isShipping'),
);
export const inboundSelectCancelingLabel = selector(
  inboundSelect,
  peek('isCancelingLabel'),
);

export const inboundSelectRateOptions = selector(
  inboundSelect,
  peek('rateOptions'),
);

// The list's single status source: a row's status comes from its cached
// detail record when one exists (nested estimate/label win), else from the
// row itself (bare `state` string).
export const inboundSelectItemsWithStatus = selector(
  inboundSelectItems,
  inboundSelectDetails,
  (items, details) =>
    items.map((row) =>
      row.set('status', deriveInboundStatus(details.get(row.get('id'), row))),
    ),
);
